import { createSelector } from 'reselect'
import { selectTravelAgentBookings } from '../travelAgent/selectors'
import { convertBookingsToTableRecords } from './utils'

export const selectAgentBookingsTableRecords = createSelector(
  selectTravelAgentBookings,
  convertBookingsToTableRecords
)
